__turbopack_context__.v({
  "brandLtr": "who-we-serve-module__cxkCfW__brandLtr",
  "callout": "who-we-serve-module__cxkCfW__callout",
  "container": "who-we-serve-module__cxkCfW__container",
  "controls": "who-we-serve-module__cxkCfW__controls",
  "desktopShot": "who-we-serve-module__cxkCfW__desktopShot",
  "glow": "who-we-serve-module__cxkCfW__glow",
  "header": "who-we-serve-module__cxkCfW__header",
  "heading": "who-we-serve-module__cxkCfW__heading",
  "icon": "who-we-serve-module__cxkCfW__icon",
  "iconBox": "who-we-serve-module__cxkCfW__iconBox",
  "iconRotated": "who-we-serve-module__cxkCfW__iconRotated",
  "image": "who-we-serve-module__cxkCfW__image",
  "imageFrame": "who-we-serve-module__cxkCfW__imageFrame",
  "item": "who-we-serve-module__cxkCfW__item",
  "itemActive": "who-we-serve-module__cxkCfW__itemActive",
  "itemBody": "who-we-serve-module__cxkCfW__itemBody",
  "itemBodyInner": "who-we-serve-module__cxkCfW__itemBodyInner",
  "itemCopy": "who-we-serve-module__cxkCfW__itemCopy",
  "itemPara": "who-we-serve-module__cxkCfW__itemPara",
  "itemTitle": "who-we-serve-module__cxkCfW__itemTitle",
  "layout": "who-we-serve-module__cxkCfW__layout",
  "leader": "who-we-serve-module__cxkCfW__leader",
  "leaderImg": "who-we-serve-module__cxkCfW__leaderImg",
  "list": "who-we-serve-module__cxkCfW__list",
  "media": "who-we-serve-module__cxkCfW__media",
  "mediaFrame": "who-we-serve-module__cxkCfW__mediaFrame",
  "mediaLayer": "who-we-serve-module__cxkCfW__mediaLayer",
  "mediaLayerActive": "who-we-serve-module__cxkCfW__mediaLayerActive",
  "navButton": "who-we-serve-module__cxkCfW__navButton",
  "overlayCallout": "who-we-serve-module__cxkCfW__overlayCallout",
  "poster": "who-we-serve-module__cxkCfW__poster",
  "section": "who-we-serve-module__cxkCfW__section",
  "shotStack": "who-we-serve-module__cxkCfW__shotStack",
  "slide": "who-we-serve-module__cxkCfW__slide",
  "slideCallout": "who-we-serve-module__cxkCfW__slideCallout",
  "slideCopy": "who-we-serve-module__cxkCfW__slideCopy",
  "stage": "who-we-serve-module__cxkCfW__stage",
  "sticky": "who-we-serve-module__cxkCfW__sticky",
  "video": "who-we-serve-module__cxkCfW__video",
  "viewport": "who-we-serve-module__cxkCfW__viewport",
});
